import type { StaticEntityType } from "@config";
import { ViewProvider } from "@editor-providers";
import { cn } from "@lib/cn";
import { Slide } from "@library-containers/layers";
import { slidePreviewStyles as styles } from "@modules/slides-library/shared";
import { type CSSProperties, memo } from "react";

export const SlidePreview = memo(
  ({
    slide,
    className,
    style,
    isIntersecting,
    shouldRender,
  }: {
    slide: StaticEntityType | null;
    className?: string;
    style?: CSSProperties;
    isIntersecting: boolean;
    shouldRender: boolean;
  }) => {
    return (
      <div
        className={cn(
          // tw-text-left seeds a neutral baseline so previews don't inherit an
          // ambient text-align (e.g. centered editor canvas) — content whose
          // alignment relies on inheritance then renders the same everywhere.
          "tw-relative tw-aspect-video tw-w-full tw-rounded-lg tw-text-left tw-outline tw-outline-1 tw-outline-blue-200 !tw-outline-offset-0 tw-bg-blue-100 tw-shadow-sm",
          className,
        )}
        style={style}
      >
        <div className="tw-absolute tw-inset-0 tw-overflow-hidden tw-rounded-lg">
          <div className={cn(styles.scaled, "tw-pointer-events-none tw-grid tw-place-items-center")}>
            <div className="tw-h-full tw-w-full">
              <div className="story tw-h-full">
                <div className="storyContent tw-h-full">
                  <div
                    className={cn(
                      "tw-h-full tw-transition-opacity tw-duration-200",
                      isIntersecting ? "tw-opacity-100" : "tw-opacity-0",
                    )}
                  >
                    {shouldRender && slide && (
                      // Render as a static thumbnail so combos like Carousel /
                      // Narrator / Timeline don't autoplay, loop, or animate in
                      // the preview (the default view leaves them "live").
                      <ViewProvider value={{ view: "thumbnail" }}>
                        <Slide entity={slide as StaticEntityType} />
                      </ViewProvider>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
